import React from "react"
import NumberFormat from "react-number-format"
import ReactSelect from "react-select"
import { CSSTransition } from "react-transition-group"
import propTypes from "prop-types"
import moment from "moment"
import {
  fieldIsNotEmpty,
  validateHours,
  validateTime
} from "../../../../../../services/validation"
import "./styles.scss"

class DayPicker extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      days: [
        {
          title: "Mon",
          name: "Mon",
          fullTitle: "Monday"
        },
        {
          title: "Tues",
          name: "Tue",
          fullTitle: "Tuesday"
        },
        {
          title: "Wed",
          name: "Wed",
          fullTitle: "Wednesday"
        },
        {
          title: "Thurs",
          name: "Thu",
          fullTitle: "Thursday"
        },
        {
          title: "Fri",
          name: "Fri",
          fullTitle: "Friday"
        },
        {
          title: "Sat",
          name: "Sat",
          fullTitle: "Saturday"
        },
        {
          title: "Sun",
          name: "Sun",
          fullTitle: "Sunday"
        }
      ],
      daysValues: {
        Mon: {
          checked: false,
          value: {
            day: {
              name: "day",
              value: "Mon"
            },
            end_time: {
              name: "end_time",
              value: "",
              message: ""
            },
            end_time_period: {
              name: "end_time_period",
              value: "AM",
              message: ""
            },
            num_hours: {
              name: "num_hours",
              value: "",
              message: ""
            },
            start_time: {
              name: "start_time",
              value: "",
              message: ""
            },
            start_time_period: {
              name: "start_time_period",
              value: "AM",
              message: ""
            }
          }
        },
        Tue: {
          checked: false,
          value: {
            day: {
              name: "day",
              value: "Tue"
            },
            end_time: {
              name: "end_time",
              value: "",
              message: ""
            },
            end_time_period: {
              name: "end_time_period",
              value: "AM",
              message: ""
            },
            num_hours: {
              name: "num_hours",
              value: "",
              message: ""
            },
            start_time: {
              name: "start_time",
              value: "",
              message: ""
            },
            start_time_period: {
              name: "start_time_period",
              value: "AM",
              message: ""
            }
          }
        },
        Wed: {
          checked: false,
          value: {
            day: {
              name: "day",
              value: "Wed"
            },
            end_time: {
              name: "end_time",
              value: "",
              message: ""
            },
            end_time_period: {
              name: "end_time_period",
              value: "AM",
              message: ""
            },
            num_hours: {
              name: "num_hours",
              value: "",
              message: ""
            },
            start_time: {
              name: "start_time",
              value: "",
              message: ""
            },
            start_time_period: {
              name: "start_time_period",
              value: "AM",
              message: ""
            }
          }
        },
        Thu: {
          checked: false,
          value: {
            day: {
              name: "day",
              value: "Thu"
            },
            end_time: {
              name: "end_time",
              value: "",
              message: ""
            },
            end_time_period: {
              name: "end_time_period",
              value: "AM",
              message: ""
            },
            num_hours: {
              name: "num_hours",
              value: "",
              message: ""
            },
            start_time: {
              name: "start_time",
              value: "",
              message: ""
            },
            start_time_period: {
              name: "start_time_period",
              value: "AM",
              message: ""
            }
          }
        },
        Fri: {
          checked: false,
          value: {
            day: {
              name: "day",
              value: "Fri"
            },
            end_time: {
              name: "end_time",
              value: "",
              message: ""
            },
            end_time_period: {
              name: "end_time_period",
              value: "AM",
              message: ""
            },
            num_hours: {
              name: "num_hours",
              value: "",
              message: ""
            },
            start_time: {
              name: "start_time",
              value: "",
              message: ""
            },
            start_time_period: {
              name: "start_time_period",
              value: "AM",
              message: ""
            }
          }
        },
        Sat: {
          checked: false,
          value: {
            day: {
              name: "day",
              value: "Sat"
            },
            end_time: {
              name: "end_time",
              value: "",
              message: ""
            },
            end_time_period: {
              name: "end_time_period",
              value: "AM",
              message: ""
            },
            num_hours: {
              name: "num_hours",
              value: "",
              message: ""
            },
            start_time: {
              name: "start_time",
              value: "",
              message: ""
            },
            start_time_period: {
              name: "start_time_period",
              value: "AM",
              message: ""
            }
          }
        },
        Sun: {
          checked: false,
          value: {
            day: {
              name: "day",
              value: "Sun"
            },
            end_time: {
              name: "end_time",
              value: "",
              message: ""
            },
            end_time_period: {
              name: "end_time_period",
              value: "AM",
              message: ""
            },
            num_hours: {
              name: "num_hours",
              value: "",
              message: ""
            },
            start_time: {
              name: "start_time",
              value: "",
              message: ""
            },
            start_time_period: {
              name: "start_time_period",
              value: "AM",
              message: ""
            }
          }
        }
      }
    }
  }

  componentDidMount() {
    const { defalutDays } = this.props
    const { daysValues } = this.state
    const newDays = {}

    defalutDays.map(day => {
      newDays[day.value.day.value] = day

      return null
    })

    this.setState({
      daysValues: {
        ...daysValues,
        ...newDays
      }
    })
  }

  handleCheckboxChange = name => {
    const { daysValues } = this.state

    this.setState(
      {
        daysValues: {
          ...daysValues,
          [name]: {
            ...daysValues[name],
            checked: !daysValues[name].checked
          }
        }
      },
      () => {
        this.sendNewDays()
      }
    )
  }

  calculateEndTime = (numHours, startTime, startTimePeriod) => {
    let endTime = ""
    let endTimePeriod = ""

    if (
      !validateHours(numHours) &&
      !validateTime(startTime) &&
      !fieldIsNotEmpty(startTimePeriod)
    ) {
      const endDate = moment(`${startTime} ${startTimePeriod}`, "hh:mm A")
      endDate.add(numHours, "hours")

      endTime = endDate.format("hh:mm")
      endTimePeriod = endDate.format("A")
    }

    return {
      end_time: {
        name: "end_time",
        value: endTime,
        message: ""
      },
      end_time_period: {
        name: "end_time_period",
        value: endTimePeriod,
        message: ""
      }
    }
  }

  getUpdatedEndTime = (day, updatedField, updatedValue) => {
    const { daysValues } = this.state
    let {
      num_hours: numHours,
      start_time: startTime,
      start_time_period: startTimePeriod
    } = daysValues[day].value

    numHours =
      updatedField === "num_hours" ? updatedValue : numHours.value || ""

    startTime =
      updatedField === "start_time" ? updatedValue : startTime.value || ""

    startTimePeriod =
      updatedField === "start_time_period"
        ? updatedValue
        : startTimePeriod.value || ""

    return this.calculateEndTime(numHours, startTime, startTimePeriod)
  }

  onChange = (value, select) => {
    const { daysValues } = this.state
    const day = select.name.split("_")[0]
    const name = select.name.split("_")[1]
    const endTimeValues = this.getUpdatedEndTime(
      day,
      `${name}_time_period`,
      value.value
    )

    this.setState(
      {
        daysValues: {
          ...daysValues,
          [day]: {
            ...daysValues[day],
            value: {
              ...daysValues[day].value,
              ...endTimeValues,
              [`${name}_time_period`]: {
                ...daysValues[day].value[`${name}_time_period`],
                message: "",
                value: value.value
              }
            }
          }
        }
      },
      () => {
        this.sendNewDays()
      }
    )
  }

  handleChange = (e, name, type) => {
    const { daysValues } = this.state
    let endTimeValues = null

    if (type === "num_hours" || type === "start_time") {
      endTimeValues = this.getUpdatedEndTime(name, type, e.target.value)
    }

    this.setState(
      {
        daysValues: {
          ...daysValues,
          [name]: {
            ...daysValues[name],
            value: {
              ...daysValues[name].value,
              ...endTimeValues,
              [type]: {
                ...daysValues[name].value[type],
                message: "",
                value: e.target.value
              }
            }
          }
        }
      },
      () => {
        this.sendNewDays()
      }
    )
  }

  handleKeyDown = e => {
    if (e.key === ":") {
      const hh = e.target.value.substring(0, 2).trim()
      const mm = e.target.value.substring(2, 4)
      if (hh.length === 1) {
        e.target.value = `0${hh}:${mm}`
      }
    }
  }

  sendNewDays = () => {
    const { daysValues } = this.state
    const { onChange, fieldName } = this.props

    const newDays = []

    Object.keys(daysValues).map(key => {
      const newDay = daysValues[key]

      if (newDay.checked) {
        newDays.push(newDay)
      }

      return null
    })

    onChange(fieldName, "value", newDays)
  }

  render() {
    const { days, daysValues } = this.state
    const { children, isSubmitted } = this.props

    const selectOptions = [
      {
        value: "AM",
        label: "AM"
      },
      {
        value: "PM",
        label: "PM"
      }
    ]

    return (
      <div className="day-picker">
        <ul className="day-picker_days">
          {days.map(day => (
            <li key={`days-${day.name}`} className="day-picker_days_item">
              <label htmlFor={`days-${day.name}`}>
                <input
                  type="checkbox"
                  onChange={() => {
                    this.handleCheckboxChange(day.name)
                  }}
                  id={`days-${day.name}`}
                  name={`days-${day.name}`}
                  defaultChecked={daysValues[day.name].checked}
                />
                <div
                  className={`day-picker_days_icon ${
                    daysValues[day.name].checked
                      ? "day-picker_days_icon--active"
                      : ""
                  }`}
                >
                  {day.title}
                </div>
              </label>
            </li>
          ))}
        </ul>

        {children}

        <ul className="day-picker_times">
          {days.map(day => (
            <CSSTransition
              in={!!daysValues[day.name].checked}
              unmountOnExit
              key={`times-${day.title}`}
              timeout={600}
              classNames="day-picker_times_item"
            >
              <li className="day-picker_times_item">
                <div className="day-picker_times_title">{day.fullTitle}</div>
                <div className="row day-picker_times_row">
                  <div
                    className={`day-picker_times_message ${
                      isSubmitted &&
                      daysValues[day.name].value.num_hours.message
                        ? " danger"
                        : ""
                    }`}
                  >
                    <em>This answer is required</em>
                  </div>
                  <div className="col-md day-picker_times_text">
                    How many hours do you need this service:
                  </div>
                  <div className="col-md day-picker_times_input">
                    <NumberFormat
                      onChange={e => {
                        this.handleChange(e, day.name, "num_hours")
                      }}
                      value={daysValues[day.name].value.num_hours.value}
                      placeholder="1"
                      className={
                        isSubmitted &&
                        daysValues[day.name].value.num_hours.message
                          ? " is-invalid"
                          : ""
                      }
                    />
                    <span className="day-picker_times_input_units">hrs</span>
                  </div>
                </div>
                <div className="row day-picker_times_row">
                  <div
                    className={`day-picker_times_message ${
                      isSubmitted &&
                      daysValues[day.name].value.start_time.message
                        ? " danger"
                        : ""
                    }`}
                  >
                    <em>This answer is required</em>
                  </div>
                  <div className="col-md day-picker_times_text">
                    What time do you want this service to start
                  </div>
                  <div className="col-md day-picker_times_input">
                    <NumberFormat
                      onKeyDown={this.handleKeyDown}
                      onChange={e => {
                        this.handleChange(e, day.name, "start_time")
                      }}
                      value={daysValues[day.name].value.start_time.value}
                      placeholder="hh:mm"
                      format="##:##"
                      className={
                        isSubmitted &&
                        daysValues[day.name].value.start_time.message
                          ? " is-invalid"
                          : ""
                      }
                    />
                    <div
                      className={`form_select day-picker_times_input_units not-searchable${
                        isSubmitted &&
                        daysValues[day.name].value.start_time_period.message
                          ? " is-invalid"
                          : ""
                      }`}
                    >
                      <ReactSelect
                        name={`${day.name}_start`}
                        inputId={day.name}
                        classNamePrefix="form_select_item"
                        placeholder="AM"
                        options={selectOptions}
                        isSearchable={false}
                        onChange={this.onChange}
                        value={selectOptions.filter(
                          option =>
                            option.label ===
                            daysValues[day.name].value.start_time_period.value
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="row day-picker_times_row">
                  <div className="col-md day-picker_times_text">
                    Planned end of service
                  </div>
                  <div className="col-md day-picker_times_input">
                    <NumberFormat
                      disabled
                      value={daysValues[day.name].value.end_time.value}
                      placeholder="hh:mm"
                      format="##:##"
                    />
                    <div className="form_select day-picker_times_input_units is-disabled not-searchable">
                      <ReactSelect
                        isDisabled
                        name={`${day.name}_end`}
                        inputId={day.name}
                        classNamePrefix="form_select_item"
                        placeholder="AM"
                        options={selectOptions}
                        isSearchable={false}
                        value={selectOptions.filter(
                          option =>
                            option.label ===
                            daysValues[day.name].value.end_time_period.value
                        )}
                      />
                    </div>
                  </div>
                </div>
              </li>
            </CSSTransition>
          ))}
        </ul>
      </div>
    )
  }
}

DayPicker.propTypes = {
  fieldName: propTypes.string.isRequired,
  onChange: propTypes.func.isRequired,
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  isSubmitted: propTypes.bool.isRequired,
  defalutDays: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.oneOfType([propTypes.string, propTypes.number]),
      day: propTypes.string,
      times: propTypes.shape({
        hours: propTypes.shape({
          time: propTypes.oneOfType([propTypes.string, propTypes.number])
        }),
        start: propTypes.shape({
          time: propTypes.oneOfType([propTypes.string, propTypes.number]),
          format: propTypes.string
        }),
        end: propTypes.shape({
          time: propTypes.oneOfType([propTypes.string, propTypes.number]),
          format: propTypes.string
        })
      })
    })
  )
}

DayPicker.defaultProps = {
  defalutDays: []
}

export default DayPicker
